import { FC, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import cn from 'classnames'
import { CreateOneModalContentClear } from '@pages/Admin/CRM/components/AddNewLeadSelect/CreateOneModalContent'
import { CRMProvider } from '@pages/Admin/CRM/CRMContext'
import { selectProfile } from '@store/profile.reducer'
import { useSelector } from 'react-redux'
import amclasses from '@pages/Admin/CRM/styles/ammodal.module.css'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import classes from './index.module.css'
import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import { useAddAlert } from '@/hooks/useAddAlert'
import LeadProfileModal from '@pages/Admin/CRM/components/LeadProfileModal/LeadProfileModal'
import { useAsync } from 'react-use'
import Button from '@UI/New/Button'
import { IcoRemove } from '@/utils/icons'
import { SelectChildren } from '@pages/Admin/CRM/components/LeadProfileModal/components/TabBindingStudAccount/AddStudAccountModal'
import EditEntityModal from '@/components/modals/EditEntityModal/EditEntityModal'
import SelectLead from './SelectLead'
import BindLeadBlock from './BindLeadBlock'

// для ant tab
const styleForLabel = {
  // чтобы перекрыть весь размер обёртки и всегда нажимать на этот <p>
  marginTop: '-12px',
  marginBottom: '-12px',
  paddingTop: '12px',
  paddingBottom: '12px',
}

interface OpenLeadProfileTabProps {
  onClick: () => void
}

interface CreateLeadProfileTabProps {
  student: IUser & { parents: { [key: string]: any }[] }
  onSuccess: () => void
}

const OpenLeadProfileTab: FC<OpenLeadProfileTabProps> = ({ onClick }) => {
  return (
    <p
      style={styleForLabel}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()

        // Проверяем, что клик произошёл именно по этому тегу, а не по вложенному
        if (e.target === e.currentTarget) onClick()
      }}
    >
      Карточка лида
    </p>
  )
}

const SetActionType = {
  CREATE: 'CREATE',
  BIND: 'BIND',
}

const CreateLeadProfileTab: FC<CreateLeadProfileTabProps> = ({
  student,
  onSuccess,
}) => {
  const addAlert = useAddAlert()

  const [open, setOpen] = useState(false)
  const closeModal = () => setOpen(false)

  const [massAction, setMassAction] = useState(SetActionType.CREATE)

  return (
    <p
      style={styleForLabel}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()

        // Проверяем, что клик произошёл именно по этому тегу, а не по вложенному
        if (e.target === e.currentTarget) setOpen(true)
      }}
      onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
        e.stopPropagation()
      }}
    >
      <PlusOutlined
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        style={{ marginRight: '8px' }}
      />{' '}
      Привязать/создать лида
      {/* Modals */}
      <CRMProvider currentTab={'new'}>
        <Modal
          open={open}
          onOk={closeModal}
          onCancel={closeModal}
          footer={null}
          title={null}
          centered
          maskClosable
          className={cn(amclasses.modal, classes.modalFullContent)}
        >
          <div className={mclasses.modalContainer}>
            <div className={mclasses.modalHeader}>
              <div className={mclasses.modalTitleContainer}>
                <span className={mclasses.modalHeaderTitle}>
                  Привязать/создать лида
                </span>
              </div>
              <div className={mclasses.closeIcon} onClick={closeModal}>
                <IcoRemove />
              </div>
            </div>
            <div className={classes.selectTypeWrapper}>
              <Button
                color={SetActionType.CREATE === massAction ? 'primary' : 'gray'}
                onClick={() => setMassAction(SetActionType.CREATE)}
              >
                Создать
              </Button>
              <Button
                color={SetActionType.BIND === massAction ? 'primary' : 'gray'}
                onClick={() => setMassAction(SetActionType.BIND)}
              >
                Привязать
              </Button>
            </div>

            {SetActionType.CREATE === massAction ? (
              <CreateOneModalContentClear
                defData={{
                  NAME: student?.name,
                  PHONE: student?.phone,
                  EMAIL: student?.email,
                  PARENTNAME: student?.parents?.length ? student.parents[0]?.name : null,
                  PARENTPHONE: student?.parents?.length ? student.parents[0]?.phone : null,
                  PARENTEMAIL: student?.parents?.length ? student.parents[0]?.email : null,
                }}
                onClose={closeModal}
                onSuccess={(lead) => {
                  if (!lead) {
                    addAlert({
                      title: 'Ошибка',
                      text: 'Ошибка при создании карточки лида',
                      type: 'error',
                    })
                    return
                  }

                  crmApi
                    .bindingStudAccount({
                      lead_id: lead.id,
                      user_id: student.id,
                    })
                    .then((res) => {
                      if (isError(res)) throw new Error()
                      addAlert({
                        title: 'Успешно',
                        text: `Успешно создан и привязан лид`,
                        type: 'success',
                      })
                      onSuccess()
                      closeModal()
                    })
                    .catch((error) => {
                      addAlert({
                        title: 'Ошибка',
                        text: 'Ошибка привязки карточки лида',
                        type: 'error',
                      })
                    })
                }}
              />
            ) : (
              <BindLeadBlock
                studentId={student.id}
                onSuccess={() => {
                  onSuccess()
                  closeModal()
                }}
              />
            )}
          </div>
        </Modal>
      </CRMProvider>
    </p>
  )
}

export { OpenLeadProfileTab, CreateLeadProfileTab }
